module.exports = __webpack_public_path__ + "1fe3faca24dd91d3093aba31c78060ee.pdf";